module.exports = __webpack_public_path__ + "static/img/fqybc12-benefit-top-bg.d2104f07.png";